import React from 'react';
import { MainLayout } from '@/components/MainLayout';
import { CategoryPage } from '@/components/categories/CategoryPage';

export default function CategoriesPage() {
  return (
    <MainLayout>
      <CategoryPage />
    </MainLayout>
  );
}

